import React from "react";
import "../../assets/scss/store/mainContent.scss";
import { Button, Carousel } from "react-bootstrap";
import { useAuth } from "../../hooks/useAuth";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import queryString from "query-string";
import { useQuery } from "react-query";
import { useQueryParams } from "../../utils/hooks";
import { ItemData } from "./Items";
import { fetchActionsUtil } from "../../utils/helpers";
import { isEmpty } from "lodash";

export default function StoreHomePage(usage = "") {
  const { customerBackendUrl: backendUrl, customer, user } = useAuth();
  const { categoryName = "", productName = "" } = useParams();
  const navigate = useNavigate();
  const generalSettings = useStoreState((state) => state.generalSettings);
  const initialFilterParams = {
    page: 1,
    limit: 6,
    barcode: "",
    itemName: "",
    q: "",
    sort: "name-asc",
    minPrice: "",
    maxPrice: "",
    onlineStoreInventorySource: customer?.onlineStoreInventorySource
      ? customer?.onlineStoreInventorySource
      : "Sales Inventory",
  };
  const [queryParams, setQueryParams] = useQueryParams({
    ...initialFilterParams,
  });

  const { data: homePage, isLoading } = useQuery(
    ["GET_HOMEPAGE"],
    async () => {
      let data = await fetchActionsUtil(
        `${backendUrl}/api/company/get-content-page`
      );

      if (data?.data?.homePage && !isEmpty(data?.data?.homePage)) {
        data = JSON.parse(data?.data?.homePage[0]?.content);
      } else {
        data = [];
      }

      if (isEmpty(data)) {
        navigate("/store/home");
      }

      return data;
    },

    {
      onSuccess: () => {},
    }
  );

  const fetchItems = async (
    queryParams,
    categoryName,
    productName,
    usage,
    onlineStoreInventory
  ) => {
    // await waitFor(5000);
    // console.log(usage);
    const onlineStore = Boolean(onlineStoreInventory)
      ? onlineStoreInventory
      : "Sales Inventory";
    let response = await fetch(
      `${backendUrl}/api/${
        usage === "customer-products" ? "store/customer-products" : "items"
      }?&${queryString.stringify({
        ...queryParams,
        product: productName,
        category: categoryName,
        Cust_ID: customer?.Cust_ID,
        showInStore: true,
        onlineStoreInventorySource: onlineStore,
      })}`,
      {
        method: "GET",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
        credentials: "include",
      }
    );

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();
    return data;
  };
  const {
    data = { count: 0, items: [] },
    refetch,
    isFetching,
    isSuccess,
    isLoading: storeLoading,
  } = useQuery(
    [`HOMEPAGE_STORE_ITEMS_${usage}_${categoryName}_${productName}`],
    () =>
      fetchItems(
        queryParams,
        categoryName,
        productName,
        usage,
        customer?.onlineStoreInventorySource
      ),
    {
      keepPreviousData: true,
    }
  );
  return (
    <main className="store-main">
      <div className="content">
        <section className="flex-md-grow-1 ">
          <Carousel>
            {!isLoading &&
              homePage?.map((home, i) => (
                <Carousel.Item key={i}>
                  <div
                    style={{
                      backgroundImage: `url("${backendUrl}/api/items/view-file/${
                        home?.image[0]
                      }")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      width: "100%",
                      height: "70vh",
                      position: "relative",
                    }}
                  >
                    {/* Overlay */}
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.5)",
                        zIndex: 1,
                      }}
                    />

                    {/* Content */}
                    <div
                      style={{
                        height: "70vh",
                        maxWidth: "700px",
                        position: "relative",
                        zIndex: 2,
                      }}
                      className="d-flex flex-column gap-3 mx-auto justify-content-center align-items-center text-white text-center"
                    >
                      <h1 className="fw-bold px-3 py-2 rounded-4">
                        {home?.title}
                      </h1>
                      <p className="fs-4 px-3 py-2">{home?.description}</p>
                      <button
                        onClick={() => navigate("/store/home")}
                        className="rounded-4 btn btn-primary py-3 px-5 fs-4 fw-semibold shadow-sm"
                      >
                        {home?.btnText}
                      </button>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
          </Carousel>
          {!isEmpty(data?.items) && (
            <section className=" my-4">
              <div className="" style={{ margin: "5rem 0" }}>
                <h1 className="text-center">Top Products</h1>
              </div>

              <section>
                <div className=" d-flex justify-content-end mb-2">
                  <Link to={"/store/home"} className=" nav-underline fw-bold">
                    View All
                  </Link>
                </div>
                <div className="items-grid m-0 gap-4">
                  {data?.items.map((el) => (
                    <ItemData
                      key={el?.Bar_Code}
                      item={el}
                      layout={"grid"}
                      hideUnitPriceInStore={
                        generalSettings?.hideUnitPriceInStore &&
                        usage !== "customer-products"
                      }
                    />
                  ))}
                </div>
              </section>
            </section>
          )}
        </section>
      </div>
    </main>
  );
}
